"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentEntryFileTypes = exports.DocumentEntryFileType = exports.DocumentEntryTypes = exports.DocumentEntryType = void 0;
var DocumentEntryType;
(function (DocumentEntryType) {
    DocumentEntryType["Directory"] = "directory";
    DocumentEntryType["File"] = "file";
})(DocumentEntryType = exports.DocumentEntryType || (exports.DocumentEntryType = {}));
exports.DocumentEntryTypes = Object.values(DocumentEntryType).filter(function (t) { return typeof t === "number"; });
var DocumentEntryFileType;
(function (DocumentEntryFileType) {
    DocumentEntryFileType["PDF"] = "pdf";
    DocumentEntryFileType["Video"] = "video";
    DocumentEntryFileType["Image"] = "image";
    DocumentEntryFileType["Other"] = "other";
})(DocumentEntryFileType = exports.DocumentEntryFileType || (exports.DocumentEntryFileType = {}));
exports.DocumentEntryFileTypes = Object.values(DocumentEntryFileType).filter(function (t) { return typeof t === "number"; });
//# sourceMappingURL=docuement-entry.js.map